import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBailiffDialogPreview } from "store/bailiff/bailiff/dialog/bailiff_dialog.action";
import { bailiffJobPreviewSelector } from "store/bailiff/bailiff/job/bailiff_job.selector";
//
//component
//redux
//selector
//actions
export const TriggerBailiffPreview = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const selected = useSelector(bailiffJobPreviewSelector);
  const id = selected?.id;
  //   const id = "k09RKnzLes543SSV3UM0";
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (id) {
      dispatch(getBailiffDialogPreview({ id }));
    }
  }, [id, dispatch]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerBailiffPreview;
